import React, { useEffect, useState } from 'react'
import { Dimensions, FlatList, StyleSheet, Text, TextInput, TouchableOpacity, View, Image, ScrollView } from 'react-native'
import { Loader } from '../customUtils/Components/Loader'
import { getConection } from '../appBar/context/HeaderContext'
import { fetchAuthSession } from 'aws-amplify/auth'
import { request_get_period, request_set_period_status, request_update_schedule_periods } from '../../services/schedule.services'
import { CreateScheduleWeek, ScheduleCalendar } from './CreateScheduleWeek'
import { STATUS_KEYS, STATUS_MODERATION, STATUS_PERIOD } from './constants/constants.stores'
import { useNavigation } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { DotsNavigation } from '../navigation/stacks/NavigationStack'
import styles from './ModeratorRelevateWeeksStyles'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { validateWeekComplete } from './CreateSchedule'
import { useBottomSheet } from '../customUtils/context/BottomSheetContext'
import theme from '../../../theme'
import type { Period, Activity, Day, Week } from './models/CreateScheduleModel'

export const ModeratorRelevateWeeks = ({ route }) => {
    const { languageFile } = getLanguage()
    const { id_period, id_week } = route.params
    const [loading, setLoading] = useState(true)
    const { isConnected, hasInternet } = getConection()
    const [period, setPeriod] = useState<Period>({ _id: '', status: -1 })
    const [activities, setActivities] = useState<Activity[]>([])
    const [distributor_activities, setDistributorActivities] = useState<Activity[]>([])
    const navigation = useNavigation<StackNavigationProp<DotsNavigation>>()
    const [selectedWeek, setSelectedWeek] = useState<number>(0)
    //console.log('🚀 ~ ModeratorRelevateWeeks ~ selectedWeek:', selectedWeek)
    const [indexDay, setIndexDay] = useState(0)
    const { openBottomSheet, closeBottomSheet } = useBottomSheet()
    const [update, setUpdate] = useState(false)
    const [monthly_distributor_activities, setMonthlyDistributorActivities] = useState<Activity[]>([])
    const [monthly_activities, setMonthlyActivities] = useState<Activity[]>([])
    useEffect(() => {
        fetchData(id_period)
    }, [])
    const sendStep = async () => {
        if (!buttonEnabled) {
            return
        }
        try {
            if (isConnected && hasInternet) {
                const session = await fetchAuthSession()
                const authToken = session.tokens?.accessToken?.toString() || ""
                let body = {}

                if (period.status == STATUS_PERIOD.PERIOD_APROBB) {
                    let filter_week = [period.weeks[selectedWeek]]
                    let info = filter_week.map((week) => {
                        //period.weeks.map((week) => {
                        return {
                            _id: week._id,
                            days: week.days.map((day) => {
                                if (day.status != STATUS_MODERATION.VACATION && day.status != STATUS_MODERATION.STATUS_DAY_OTHER_MONTH) {
                                    let dayStatus = day.status == 4 ? 1 : day.status
                                    if (day.distributor == null) {
                                        return {
                                            _id: day._id,
                                            status: 0,
                                            status_day: dayStatus,
                                            activities:
                                                day.activities.map((a) => {
                                                    let status = a.status ? a.status : 0
                                                    if (status != -1) {
                                                        status = 1
                                                    }
                                                    return { _id: a._id, status: status }
                                                }) ?? [],
                                            distributor_activities:
                                                day.distributor_activities.map((a) => {
                                                    let status = a.status ? a.status : 0
                                                    if (status != -1) {
                                                        status = 1
                                                    }
                                                    return { _id: a._id, status: status }
                                                }) ?? [],
                                            monthly_activities:
                                                day.monthly_activities.map((a) => {
                                                    let status = a.status ? a.status : 0
                                                    if (status != -1) {
                                                        status = 1
                                                    }
                                                    return { _id: a._id, status: status }
                                                }) ?? [],
                                            monthly_distributor_activities:
                                                day.monthly_distributor_activities.map((a) => {
                                                    let status = a.status ? a.status : 0
                                                    if (status != -1) {
                                                        status = 1
                                                    }
                                                    return { _id: a._id, status: status }
                                                }) ?? [],
                                        }
                                    } else {
                                        return {
                                            _id: day._id,
                                            distributor_id: day.distributor._id,
                                            status: day.distributor.status,
                                            status_day: dayStatus,
                                            activities:
                                                day.activities.map((a) => {
                                                    let status = a.status ? a.status : 0
                                                    if (status != -1) {
                                                        status = 1
                                                    }
                                                    return { _id: a._id, status: status }
                                                }) ?? [],
                                            distributor_activities:
                                                day.distributor_activities.map((a) => {
                                                    let status = a.status ? a.status : 0
                                                    if (status != -1) {
                                                        status = 1
                                                    }
                                                    return { _id: a._id, status: status }
                                                }) ?? [],
                                            monthly_activities:
                                                day.monthly_activities.map((a) => {
                                                    let status = a.status ? a.status : 0
                                                    if (status != -1) {
                                                        status = 1
                                                    }
                                                    return { _id: a._id, status: status }
                                                }) ?? [],
                                            monthly_distributor_activities:
                                                day.monthly_distributor_activities.map((a) => {
                                                    let status = a.status ? a.status : 0
                                                    if (status != -1) {
                                                        status = 1
                                                    }
                                                    return { _id: a._id, status: status }
                                                }) ?? [],
                                        }
                                    }
                                } else {
                                    return {
                                        _id: day._id,
                                        status: 0,
                                        status_day: day.status,
                                        activities: [],
                                        distributor_activities: [],
                                        monthly_activities:
                                            day.monthly_activities.map((a) => {
                                                return { _id: a._id, status: a.status ? a.status : 0 }
                                            }) ?? [],
                                        monthly_distributor_activities: [],
                                        distributor_id: null,
                                    }
                                }
                            }),
                        }
                    })

                    body = {
                        key: STATUS_KEYS.KEY_SET_WEEKS,
                        period_id: period._id,
                        data: info,
                    }

                    console.log('envio esto--', JSON.stringify(body))

                    const data = await request_set_period_status({ authToken, body })
                    console.log('DATA', JSON.stringify(data))

                    if (!data) {
                        return
                    }

                    closeBottomSheet(true)
                    if (data.status == 1) {
                        // let updatedPeriod = { ...period }
                        // updatedPeriod.weeks[selectedWeek].status = 8
                        // setPeriod(updatedPeriod)
                        // let weekUpdate = data.single.period.weeks.find((w) => w._id.toString() == period.weeks[selectedWeek]._id.toString())

                        // period.weeks[selectedWeek].days = period.weeks[selectedWeek].days.map((d) => {
                        //     let matchingDay = weekUpdate.days.find((d2) => d2._id.toString() == d._id.toString())

                        //     // Si se encuentra un día coincidente en `weekUpdate`, actualiza el status
                        //     if (matchingDay) {
                        //         return {
                        //             ...d,
                        //             status: matchingDay.status,
                        //         }
                        //     }

                        //     // Si no se encuentra, retorna el día original sin cambios
                        //     return d
                        // })

                        // period.weeks[selectedWeek].status = weekUpdate.status
                        closeBottomSheet(true)
                        navigation.goBack()
                        // openSentWeekSheet()
                    }
                }
            }
        } catch (error) {}
    }

    const fetchData = async (id_period: string) => {
        try {
            if (isConnected) {
                const session = await fetchAuthSession()
                const authToken = session.tokens?.accessToken?.toString() || ""
                const data = await request_get_period({ authToken, id_period })
                //console.log('id_period', id_period, authToken)

                if (!data) {
                    setLoading(false)
                    return
                }
                if (data.period) {
                    let period = data.period
                    setDistributorActivities(data.distributor_activities ?? [])
                    setActivities(data.activities)
                    setMonthlyActivities(data.monthly_activities ?? []) //Otras actividades mensuales
                    let monthly_activities = data.monthly_distributor_activities ?? []
                    let monthActs = monthly_activities.map((activity) => {
                        let related = activity.related_distributors ?? []
                        return { ...activity, related_distributors: related }
                    })
                    setMonthlyDistributorActivities(monthActs ?? []) //Actividades mensuales de distribuidor
                    const today = new Date() // Fecha actual
                    today.setUTCHours(0, 0, 0, 0) // Establecer la hora a las 00:00 en UTC
                    const updatedWeeks = period.weeks.map((week) => {
                        const updatedDays = week.days.map((day) => {
                            const dateFromObject = new Date(day.date)
                            day.previous_day = dateFromObject < today
                            if (day.distributor != null) {
                                let distributor = period.distributors.find((distributor) => distributor._id === day.distributor._id)
                                if (distributor) {
                                    distributor.status = day.distributor.status
                                    day.distributor = distributor
                                }
                            }
                            if (day.activities.length > 0) {
                                day.activities = day.activities.map((activity) => {
                                    let act = data.activities.find((a) => a._id === activity._id)
                                    if (act) {
                                        return { ...act, status: activity.status ?? 0 }
                                    }
                                    return activity
                                })
                            }
                            if (day.distributor_activities && day.distributor_activities.length > 0) {
                                day.distributor_activities = day.distributor_activities.map((activity) => {
                                    let act = data.distributor_activities.find((a) => a._id === activity._id)
                                    if (act) {
                                        return { ...act, status: activity.status ?? 0 }
                                    }
                                    return activity
                                })
                            } else {
                                day.distributor_activities = []
                            }
                            if (day.monthly_distributor_activities && day.monthly_distributor_activities.length > 0) {
                                day.monthly_distributor_activities = day.monthly_distributor_activities.map((activity) => {
                                    let act = data.monthly_distributor_activities.find((a) => a._id === activity._id)
                                    if (act) {
                                        return { ...act, status: activity.status ?? 0 }
                                    }
                                    return activity
                                })
                            } else {
                                day.monthly_distributor_activities = []
                            }
                            if (day.monthly_activities && day.monthly_activities.length > 0) {
                                day.monthly_activities = day.monthly_activities.map((activity) => {
                                    let act = data.monthly_activities.find((a) => a._id === activity._id)
                                    if (act) {
                                        return { ...act, status: activity.status ?? 0 }
                                    }
                                    return activity
                                })
                            } else {
                                day.monthly_activities = []
                            }
                            return day
                        })
                        return { ...week, days: updatedDays }
                    })

                    let selectedWeek = period.weeks.findIndex((week) => week._id === id_week)
                    if (selectedWeek == -1) {
                        selectedWeek = 0
                    }
                    setSelectedWeek(selectedWeek)
                    findFirstDay(period.weeks[selectedWeek].days)
                    setPeriod({ ...period, weeks: updatedWeeks })
                }

                setLoading(false)
            }
        } catch (error) {
            console.log('error', error)
            setLoading(false)
        }
    }
    const setWeek = (index: number) => {
        let newIndex = selectedWeek + index
        if (period.weeks[newIndex]) {
            setSelectedWeek(newIndex)
            findFirstDay(period.weeks[newIndex].days)
        }
    }
    const findFirstDay = (days: Day[]) => {
        if (!days) {
            return
        }
        let dayIndex = days.findIndex((day) => day.status != STATUS_PERIOD.STATUS_DAY_OTHER_MONTH)
        if (dayIndex == -1) {
            dayIndex = 0
        }
        setIndexDay(dayIndex)
    }
    const updatePeriod = (period: Period) => {
        setPeriod(period)
        setUpdate(true)
    }
    const enableButtonSend = () => {
        let enable = false
        //Envio semanal
        if (period.status == STATUS_PERIOD.PERIOD_APROBB) {
            let currentWeek = period.weeks[selectedWeek]
            let weekComplete = true
            weekComplete = validateWeekComplete(currentWeek, period.status)
            if (weekComplete == true && currentWeek.status != 3) {
                enable = true
            }
            if (currentWeek.status == STATUS_PERIOD.PENDING_CHANGE_REQUIRED_WEEKS) {
                enable = false
            }
        }
        // Validación por mes
        // if (period.status == STATUS_PERIOD.PERIOD_APROBB) {
        //     let allComplete = true
        //     const allWeeks = period.weeks.forEach((week) => {
        //         let weekComplete = true
        //         weekComplete = validateWeekCompleteActivitys(week)
        //         if (weekComplete == true && week.status != STATUS_PERIOD.PERIOD_APROBB) {
        //             weekComplete = true
        //         }
        //         if (week.status == STATUS_PERIOD.PENDING_CHANGE_REQUIRED_WEEKS) {
        //             weekComplete = false
        //         }
        //         if (weekComplete == false) {
        //             allComplete = false
        //         }
        //     })
        //     enable = allComplete
        // }
        return enable
    }
    const showButtonSend = () => {
        let show = true
        if (period.status == STATUS_PERIOD.PERIOD_APROBB) {
            let allWeeksOk = period.weeks.every((week) => week.status == STATUS_PERIOD.PERIOD_APROBB)
            if (allWeeksOk) {
                show = true
            }
        }
        return show
    }
    const validateWeekCompleteActivitys = (week: Week) => {
        let weekComplete = true

        week.days.forEach((day) => {
            if (day.status != STATUS_MODERATION.VACATION && day.status != STATUS_MODERATION.STATUS_DAY_OTHER_MONTH) {
                if (day.distributor != null) {
                    if (day.distributor_activities.length == 0) {
                        // weekComplete = false
                    } else {
                        let allStatus = day.distributor_activities.some((activity) => activity.status == 0)
                        if (allStatus) {
                            // weekComplete = false
                        }
                    }
                } else {
                    //Sabado
                    if (day.day != 5) {
                        if (day.monthly_activities.length > 0 && day.monthly_activities.some((activity) => activity.form_id)) {
                            console.log('Tengo form id, por lo que deberia de habilitar el envio')
                        } else {
                            weekComplete = false
                            console.log('No tengo form id')
                        }
                        weekComplete = false
                    } else {
                        if (day.distributor_activities.length == 0) {
                            // weekComplete = false
                        } else {
                            let allStatus = day.distributor_activities.some((activity) => activity.status == 0)
                            if (allStatus) {
                                // weekComplete = false
                            }
                        }
                    }
                }
            }
        })

        return weekComplete
    }
    const openSentWeekSheet = () => {
        openBottomSheet(
            <SentWeekManagerModal
                close={() => {
                    //     let newIndex = selectedWeek + 1
                    //     if (period.weeks[newIndex]) {
                    //         setSelectedWeek(newIndex)
                    //         setIndexDay(0)
                    //     } else {
                    navigation.goBack()
                    // }
                    closeBottomSheet(true)
                }}
                closeBottomSheet={() => closeBottomSheet(true)}
            />,
        )
    }
    let buttonEnabled = enableButtonSend()
    let showButton = showButtonSend()
    if (loading) {
        return <Loader />
    }
    const validateActivitysStatus = (day: Day) => {
        let allAprobed = true
        let distributor_activities = day.distributor_activities ?? []
        let monthly_distributor_activities = day.monthly_distributor_activities ?? []
        let monthly_activities = day.monthly_activities ?? []

        if (distributor_activities.length > 0 && distributor_activities.some((a) => a.status != 1 && a.status != 2)) {
            allAprobed = false
        }

        if (monthly_distributor_activities.length > 0 && monthly_distributor_activities.some((a) => a.status != 1 && a.status != 2)) {
            allAprobed = false
        }
        if (monthly_activities.length > 0 && monthly_activities.some((a) => a.status != 1 && a.status != 2)) {
            allAprobed = false
        }

        return allAprobed
    }
    const aprobbeAll = (selectedWeek) => {
        let newPeriod = { ...period }
        newPeriod.weeks[selectedWeek].days = newPeriod.weeks[selectedWeek].days.map((day) => {
            if (
                day.status != STATUS_PERIOD.PERIOD_APROBB &&
                day.status != STATUS_PERIOD.VACATION &&
                day.status != STATUS_MODERATION.STATUS_DAY_OTHER_MONTH
            ) {
                day.distributor_activities = day.distributor_activities.map((activity) => {
                    let status = activity.status
                    if (status == 0) {
                        status = 1
                    }
                    activity.status = status
                    return activity
                })
                day.monthly_distributor_activities = day.monthly_distributor_activities.map((activity) => {
                    let status = activity.status
                    if (status == 0) {
                        status = 1
                    }
                    activity.status = status
                    return activity
                })
                day.monthly_activities = day.monthly_activities.map((activity) => {
                    let status = activity.status
                    if (status == 0) {
                        status = 1
                    }
                    activity.status = status
                    return activity
                })
                if (day.status != 8) {
                    let allAprobed = validateActivitysStatus(day)
                    day.status = allAprobed ? STATUS_PERIOD.PERIOD_APROBB : STATUS_PERIOD.PENDING_CHANGE_REQUIRED_WEEKS
                }
            }
            return day
        })

        setPeriod(newPeriod)
    }

    const setIndexDayFn = (index: number) => {
        if (!period || !period.weeks || !period.weeks[selectedWeek]) {
            return
        }

        const days = period.weeks[selectedWeek]['days']
        if (!Array.isArray(days) || index < 0 || index >= days.length) {
            return
        }

        const day = days[index]
        if (!day || day.status === STATUS_PERIOD.STATUS_DAY_OTHER_MONTH) {
            return
        }

        setIndexDay(index)
    }
    const updateMonthlyDistributorActivities = (acts: Activity[]) => {
        setMonthlyDistributorActivities(acts)
    }
    const updateMonthlyActivities = (acts: Activity[]) => {
        setMonthlyActivities(acts)
    }
    return (
        <View style={styles.container}>
            <ScrollView style={{ flex: 1 }}>
                <CreateScheduleWeek
                    period={period}
                    updatePeriod={updatePeriod}
                    distributor_activities={distributor_activities}
                    isModerator={true}
                    indexWeek={selectedWeek}
                    indexDay={indexDay}
                    setWeek={(index) => setWeek(index)}
                    setIndexDay={(index) => setIndexDayFn(index)}
                    lockExecutive={false}
                    activities={activities}
                    monthly_distributor_activities={monthly_distributor_activities}
                    monthly_activities={monthly_activities}
                    updateMonthlyDistributorActivities={updateMonthlyDistributorActivities}
                    updateMonthlyActivities={updateMonthlyActivities}
                />
                {/* <View style={{ height: 50 }} /> */}
            </ScrollView>
            {showButton && (
                <View style={styles.buttonContainer}>
                    {period.weeks[selectedWeek].status == STATUS_PERIOD.PENDING_APPROBB_WEEKS && (
                        <TouchableOpacity
                            style={styles.borderButton}
                            onPress={() => {
                                aprobbeAll(selectedWeek)
                            }}
                        >
                            <Text style={styles.borderButtonText}>{'Confirmar semana'}</Text>
                        </TouchableOpacity>
                    )}
                    <TouchableOpacity
                        style={buttonEnabled ? styles.mainButton : styles.mainButtonDisabled}
                        onPress={() => {
                            openBottomSheet(<SentWeekManagerModal close={() => sendStep()} closeBottomSheet={() => closeBottomSheet(true)} />)
                        }}
                        disabled={buttonEnabled ? false : true}
                    >
                        <Text style={buttonEnabled ? styles.mainButtonText : styles.mainButtonTextDisabled}>{languageFile.send}</Text>
                    </TouchableOpacity>
                </View>
            )}
        </View>
    )
}

export const ConfirmSendWeekManager = ({ close, closeBottomSheet }) => {
    const { languageFile } = getLanguage()

    let image = require('../../../assets/alertSchedule.png')
    let title = 'Estás modificando la semana'
    let desc =
        'Puedes ajustar la planificación semanal de tus ejecutivos según las necesidades. Ellos deberán seguir y realizar las actividades y/o el plan que les has asignado para esa semana.'
    let button = 'Confirmar y enviar'

    return (
        <View>
            <Image style={styles.imageAsset} source={image} resizeMode='contain'></Image>
            <Text style={styles.titleText}>{title}</Text>
            <Text style={styles.descriptionText}>{desc}</Text>
            <TouchableOpacity style={styles.borderButton} onPress={close}>
                <Text style={styles.borderButtonText}>{button}</Text>
            </TouchableOpacity>
            <TouchableOpacity style={[styles.borderButton, { borderColor: theme.colors.error }]} onPress={() => closeBottomSheet(true)}>
                <Text style={[styles.borderButtonText, { color: theme.colors.error }]}>{languageFile.cancel}</Text>
            </TouchableOpacity>
            <View style={styles.spacer1}></View>
            <View style={styles.spacer2}></View>
        </View>
    )
}
export const SentWeekManagerModal = ({ close, closeBottomSheet }) => {
    const { languageFile } = getLanguage()
    //Chequear textos y modificarlos
    let image = require('../../../assets/approvedSchedule.png')
    let title = 'Estás modificando la semana'
    let desc =
        'Puedes ajustar la planificación semanal de tus ejecutivos según las necesidades. Ellos deberán seguir y realizar las actividades y/o el plan que les has asignado para esa semana.'
    let button = 'Confirmar y enviar'

    return (
        <View>
            <Image style={styles.imageAsset} source={image} resizeMode='contain'></Image>
            <Text style={styles.titleText}>{title}</Text>
            <Text style={styles.descriptionText}>{desc}</Text>
            <TouchableOpacity style={styles.borderButton} onPress={close}>
                <Text style={styles.borderButtonText}>{button}</Text>
            </TouchableOpacity>
            <TouchableOpacity style={[styles.borderButton, { borderColor: theme.colors.error }]} onPress={() => closeBottomSheet(true)}>
                <Text style={[styles.borderButtonText, { color: theme.colors.error }]}>{languageFile.cancel}</Text>
            </TouchableOpacity>
            <View style={styles.spacer1}></View>
            <View style={styles.spacer2}></View>
        </View>
    )
}
